module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--white-on-orange-c2c7f1da903ccc20b5e92316b011b8a1.png";